import React from 'react'

const Recommendation = () => {
  return (
    <div>
      Recommendation
    </div>
  )
}

export default Recommendation
